export interface ComicCategory {
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  chapters: number;
  rating: number;
  status: "连载" | "完结";
  isVip: boolean;
  isHot: boolean;
  desc: string;
  tags: string[];
  cover: string;
}

export const comicCategories: ComicCategory[] = [
  {
    name: "都市豪门",
    icon: "ri-bank-line",
    count: 486,
    desc: "豪门恩怨与逆袭爽文，看尽阶层翻转",
  },
  {
    name: "逆袭打脸",
    icon: "ri-flashlight-line",
    count: 352,
    desc: "废柴翻身，一路碾压，痛快升级",
  },
  {
    name: "热血战斗",
    icon: "ri-fire-line",
    count: 298,
    desc: "燃到极致的打斗场面与热血燃魂",
  },
  {
    name: "奇幻异界",
    icon: "ri-sword-line",
    count: 241,
    desc: "异世界冒险，魔法与剑的碰撞",
  },
  {
    name: "都市异能",
    icon: "ri-magic-line",
    count: 205,
    desc: "觉醒超能力，都市生活暗藏玄机",
  },
  {
    name: "校园恋爱",
    icon: "ri-heart-line",
    count: 178,
    desc: "青涩心动，甜蜜与纠结并存的校园故事",
  },
];

export const hotComics: Comic[] = [
  {
    id: "c01",
    title: "千金归来",
    author: "金大贤",
    category: "都市豪门",
    chapters: 328,
    rating: 9.6,
    status: "连载",
    isVip: true,
    isHot: true,
    desc: "流落十八年的豪门千金一朝觉醒，带着满身本领回到商界巨擘世家。昔日轻视她的人，都将为今天的轻视付出代价。原版高画质，VIP 章节抢先解锁。",
    tags: ["豪门", "复仇", "逆袭"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20illustration%20of%20a%20confident%20young%20woman%20in%20an%20elegant%20black%20dress%2C%20standing%20in%20front%20of%20a%20luxury%20city%20skyline%2C%20dramatic%20warm%20golden%20lighting%2C%20rich%20detailed%20anime%20style%20artwork%2C%20dynamic%20pose%2C%20cinematic%20composition%2C%20vivid%20colors&width=600&height=840&seq=cover-c01&orientation=portrait",
  },
  {
    id: "c02",
    title: "最强赘婿",
    author: "朴振宇",
    category: "逆袭打脸",
    chapters: 412,
    rating: 9.4,
    status: "连载",
    isVip: true,
    isHot: true,
    desc: "上门赘婿被家族百般羞辱，却不知他真实身份竟是隐藏的绝顶强者。当真相揭晓，曾经踩在他头上的人，一个都跑不掉。",
    tags: ["赘婿", "打脸", "强者"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20of%20a%20powerful%20young%20man%20in%20a%20black%20suit%2C%20burning%20golden%20flames%20behind%20him%2C%20menacing%20cool%20expression%2C%20dark%20city%20background%20at%20night%2C%20warm%20orange%20glow%2C%20detailed%20anime%20artwork%2C%20high%20contrast%2C%20cinematic&width=600&height=840&seq=cover-c02&orientation=portrait",
  },
  {
    id: "c03",
    title: "异界武神归来",
    author: "李承焕",
    category: "热血战斗",
    chapters: 356,
    rating: 9.7,
    status: "连载",
    isVip: false,
    isHot: true,
    desc: "异界一代武神渡劫失败，重回地球少年时代。这一世，他要用无敌战力，守护想要守护的一切，横扫一切敢来挑衅之人。",
    tags: ["武神", "重生", "热血"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20muscular%20warrior%20wielding%20a%20glowing%20energy%20blade%2C%20energy%20waves%20and%20sparks%20flying%2C%20epic%20battle%20background%20with%20mountains%20and%20stormy%20sky%2C%20dynamic%20fighting%20pose%2C%20detailed%20anime%20artwork%2C%20intense%20warm%20and%20dark%20tones&width=600&height=840&seq=cover-c03&orientation=portrait",
  },
  {
    id: "c04",
    title: "太子妃升职记",
    author: "郑慧珍",
    category: "都市豪门",
    chapters: 289,
    rating: 9.3,
    status: "完结",
    isVip: true,
    isHot: false,
    desc: "穿越成不受宠的豪门千金，凭现代智慧一路逆袭，在勾心斗角的豪门世家站稳脚跟，最终登上人生的巅峰。",
    tags: ["穿越", "宫斗", "逆袭"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20an%20elegant%20young%20noblewoman%20in%20a%20flowing%20hanbok%20style%20dress%2C%20ornate%20palace%20background%2C%20soft%20warm%20golden%20light%2C%20refined%20detailed%20anime%20artwork%2C%20graceful%20pose%2C%20rich%20colors%2C%20romantic%20atmosphere&width=600&height=840&seq=cover-c04&orientation=portrait",
  },
  {
    id: "c05",
    title: "巅峰医尊",
    author: "韩在民",
    category: "都市异能",
    chapters: 304,
    rating: 9.2,
    status: "连载",
    isVip: true,
    isHot: false,
    desc: "身怀逆天医术的少年，在都市中凭借一手生死人肉白骨的绝技，赢得尊重与财富，也卷入一场场神秘风云。",
    tags: ["医术", "都市", "异能"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20young%20doctor%20in%20a%20white%20coat%20holding%20a%20glowing%20green%20energy%20orb%2C%20modern%20hospital%20and%20city%20background%2C%20teal%20and%20gold%20accents%2C%20mysterious%20detailed%20anime%20artwork%2C%20confident%20pose%2C%20cinematic%20lighting&width=600&height=840&seq=cover-c05&orientation=portrait",
  },
  {
    id: "c06",
    title: "神级主播",
    author: "崔光洙",
    category: "都市异能",
    chapters: 277,
    rating: 9.1,
    status: "连载",
    isVip: false,
    isHot: true,
    desc: "一个平平无奇的游戏主播，偶然觉醒「预知未来」的超能力。从此直播间封神，人生也彻底改写。",
    tags: ["直播", "预知", "爽文"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20young%20gamer%20with%20headset%20at%20a%20neon%20lit%20gaming%20setup%2C%20floating%20holographic%20screens%20and%20glowing%20energy%2C%20purple%20and%20gold%20neon%20ambience%2C%20dynamic%20detailed%20anime%20artwork%2C%20exciting%20atmosphere&width=600&height=840&seq=cover-c06&orientation=portrait",
  },
  {
    id: "c07",
    title: "豪门影帝的隐藏身份",
    author: "文智恩",
    category: "都市豪门",
    chapters: 241,
    rating: 9.0,
    status: "连载",
    isVip: true,
    isHot: false,
    desc: "娱乐圈影帝表面风光，实则隐瞒着惊天家世。当隐藏的身份一步步曝光，所有人都惊掉了下巴。",
    tags: ["娱乐圈", "影帝", "豪门"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20handsome%20celebrity%20actor%20in%20a%20stylish%20overcoat%2C%20red%20carpet%20and%20flashing%20cameras%20behind%2C%20warm%20spotlight%2C%20charming%20smile%2C%20detailed%20anime%20artwork%2C%20glamorous%20cinematic%20atmosphere%2C%20rich%20warm%20tones&width=600&height=840&seq=cover-c07&orientation=portrait",
  },
  {
    id: "c08",
    title: "觉醒：御兽宗师",
    author: "尹相赫",
    category: "奇幻异界",
    chapters: 332,
    rating: 9.5,
    status: "连载",
    isVip: false,
    isHot: true,
    desc: "灵力复苏的异界，少年意外觉醒御兽天赋。从一只低阶灵兽开始，一步步成长为人人敬畏的御兽宗师。",
    tags: ["御兽", "觉醒", "冒险"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20young%20beast%20tamer%20with%20a%20glowing%20spirit%20beast%20beside%20him%2C%20magical%20forest%20and%20floating%20spells%20background%2C%20golden%20and%20teal%20energy%20light%2C%20epic%20fantasy%20detailed%20anime%20artwork%2C%20adventurous%20composition&width=600&height=840&seq=cover-c08&orientation=portrait",
  },
  {
    id: "c09",
    title: "霸总的甜宠日常",
    author: "姜秀雅",
    category: "校园恋爱",
    chapters: 196,
    rating: 9.2,
    status: "完结",
    isVip: false,
    isHot: false,
    desc: "冷面霸总遇上元气少女，从针锋相对到满心欢喜。高甜无虐，直击少女心的治愈恋爱故事。",
    tags: ["霸总", "甜宠", "恋爱"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20romantic%20young%20couple%2C%20handsome%20businessman%20and%20cute%20girl%20under%20a%20cherry%20blossom%20tree%2C%20soft%20warm%20pink%20and%20golden%20light%2C%20sweet%20atmosphere%2C%20detailed%20cute%20anime%20artwork%2C%20romantic%20cinematic%20feel&width=600&height=840&seq=cover-c09&orientation=portrait",
  },
  {
    id: "c10",
    title: "镇国战神",
    author: "赵明秀",
    category: "热血战斗",
    chapters: 397,
    rating: 9.6,
    status: "连载",
    isVip: true,
    isHot: true,
    desc: "边疆十载，戎马归来。昔日战神退伍回乡，却发现故人受难、家国动荡。这一战，他要为兄弟讨回公道。",
    tags: ["战神", "热血", "回归"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20military%20general%20in%20a%20decorated%20officer%20uniform%20with%20a%20torn%20flag%20behind%2C%20battlefield%20with%20embers%20and%20smoke%2C%20golden%20and%20red%20tones%2C%20epic%20detailed%20anime%20artwork%2C%20heroic%20stance%2C%20cinematic%20war%20scene&width=600&height=840&seq=cover-c10&orientation=portrait",
  },
  {
    id: "c11",
    title: "废柴觉醒：灵厨",
    author: "柳真率",
    category: "奇幻异界",
    chapters: 254,
    rating: 9.0,
    status: "连载",
    isVip: false,
    isHot: false,
    desc: "被宗门抛弃的废柴少年，意外觉醒上古灵厨传承。以食入道，烹饪天下，一步登天震惊整个修真界。",
    tags: ["美食", "修真", "逆袭"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20young%20chef%20in%20traditional%20robes%20stirring%20a%20giant%20wok%20with%20golden%20spiritual%20energy%20rising%2C%20ancient%20oriental%20kitchen%20background%2C%20warm%20golden%20steam%2C%20detailed%20anime%20artwork%2C%20cozy%20yet%20epic%20atmosphere&width=600&height=840&seq=cover-c11&orientation=portrait",
  },
  {
    id: "c12",
    title: "青春侧耳倾听",
    author: "裴多彬",
    category: "校园恋爱",
    chapters: 168,
    rating: 9.1,
    status: "完结",
    isVip: false,
    isHot: false,
    desc: "校园乐队主唱与害羞吉他手，在音乐与青春里相互靠近。细腻而动人的成长恋爱物语。",
    tags: ["校园", "音乐", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20two%20high%20school%20students%20with%20guitars%20under%20soft%20sunset%20light%20on%20a%20school%20rooftop%2C%20warm%20orange%20and%20gold%20tones%2C%20nostalgic%20detailed%20anime%20artwork%2C%20gentle%20youthful%20atmosphere%2C%20melancholic%20and%20sweet&width=600&height=840&seq=cover-c12&orientation=portrait",
  },
];

export const heroComics = [hotComics[0], hotComics[2], hotComics[7], hotComics[9]];